export const AXIS_ORIGIN_X = 73.392;
export const AXIS_ORIGIN_Y = 69.645;

export const GRADE_K0 = {
    1: 1,
    2: 1.071,
    3: 1.061,
    4: 1.081,
    5: 1.068,
    6: 1.088,
    7: 1.088,
    8: 1.088,
    9: 1.088,
};

export const GRADE_NAME_TO_LEVEL = {
    一年级: 1,
    二年级: 2,
    三年级: 3,
    四年级: 4,
    五年级: 5,
    六年级: 6,
    七年级: 7,
    八年级: 8,
    九年级: 9,
};

/** term_id 编码：年级 = term_id / 2 */
export function getGradeFromTermId(termId) {
    if (termId == null || termId === '') return null;
    const grade = Number(termId) / 2;
    if (Number.isNaN(grade) || grade <= 0) return null;
    return grade;
}

export function parseGradeLevel(gradeValue) {
    if (gradeValue == null || gradeValue === '') return 1;
    const num = Number(gradeValue);
    if (!Number.isNaN(num) && num >= 1 && num <= 9) return num;
    const fromName = GRADE_NAME_TO_LEVEL[String(gradeValue)];
    if (fromName) return fromName;
    const match = String(gradeValue).match(/([1-9])年级/);
    if (match) return Number(match[1]);
    return 1;
}

export function getGradeK0(gradeValue) {
    const level = parseGradeLevel(gradeValue);
    return GRADE_K0[level] ?? 1;
}

export function getQuadrantAxis(gradeValue) {
    const k0 = getGradeK0(gradeValue);
    return {
        k0,
        axisX: AXIS_ORIGIN_X * k0,
        axisY: AXIS_ORIGIN_Y * k0,
    };
}

/** 无 GradeValue 时使用基础原点（k0=1） */
export function resolveQuadrantConfig(gradeValue) {
    if (gradeValue == null || gradeValue === '') {
        return {
            k0: 1,
            axisX: AXIS_ORIGIN_X,
            axisY: AXIS_ORIGIN_Y,
        };
    }
    return getQuadrantAxis(gradeValue);
}

export function resolveItemGrade(item, fallbackGradeValue) {
    const fromTerm = getGradeFromTermId(item && item.term_id);
    if (fromTerm != null) return fromTerm;
    if (fallbackGradeValue != null && fallbackGradeValue !== '') {
        return fallbackGradeValue;
    }
    return null;
}

export function scalePoint(x, y, gradeValue) {
    const { k0 } = resolveQuadrantConfig(gradeValue);
    const nx = Number(x);
    const ny = Number(y);
    if (Number.isNaN(nx) || Number.isNaN(ny)) return null;
    return { x: nx * k0, y: ny * k0, k0 };
}

/** 教师端四象限：由维度分合成努力/天赋原始值 */
export function buildEffortTalentFromStuItem(item) {
    if (!item) return null;
    const rawX = (Number(item.centerPos) + Number(item.gridSize) + Number(item.comboRel) + Number(item.multiDist)) / 4;
    const rawY = (Number(item.glyphGrav) + Number(item.strokeRel) + Number(item.rewindRel)) / 3;
    if (Number.isNaN(rawX) || Number.isNaN(rawY)) return null;
    return { rawX, rawY };
}

/** 教师端四象限散点：stuList → ECharts scatter data */
export function buildQuadrantScatterFromStuList(stuList, gradeValue) {
    return (stuList || []).reduce((acc, item) => {
        const point = buildEffortTalentFromStuItem(item);
        if (!point) return acc;
        const scaled = scalePoint(point.rawX, point.rawY, gradeValue);
        if (!scaled) return acc;
        acc.push({
            name: item.stuName,
            value: [scaled.x, scaled.y],
        });
        return acc;
    }, []);
}

export function buildMarkLineData(axisX, axisY) {
    return [
        { xAxis: axisX, label: { show: true, position: 'start', formatter: '大众型' } },
        { yAxis: axisY, label: { show: true, position: 'start', formatter: '自然成长' } },
        { xAxis: axisX, label: { show: true, position: 'end', formatter: '天赋型' } },
        { yAxis: axisY, label: { show: true, position: 'end', formatter: '笃行不倦' } },
    ];
}

/** 返回象限序号 1-4，无法判定时返回 null */
export function classifyQuadrantIndex(x, y, gradeValue) {
    const point = scalePoint(x, y, gradeValue);
    if (!point) return null;
    const { axisX, axisY } = resolveQuadrantConfig(gradeValue);
    const { x: sx, y: sy } = point;
    if (sx >= axisX && sy >= axisY) return 1;
    if (sx < axisX && sy >= axisY) return 2;
    if (sx < axisX && sy < axisY) return 3;
    if (sx >= axisX && sy < axisY) return 4;
    return null;
}
